import * as React from "react"

const ChevronDown = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="16" height="16" viewBox="0 0 16 16" {...props}>
    <path d="M8 10.7 4.3 7l.7-.7 3 3 3-3 .7.7L8 10.7Z" />
  </svg>
)

export default ChevronDown
